import React, {ReactNode} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";


interface MobileNavigationProps {
    setMobileMenuVisible: Function
    children: ReactNode
}

export default function MobileNavigationWrapper(props:MobileNavigationProps) {
    return (
        <div className="overflow-x-hidden">
            <div className="bg-white h-[84px] py-6 z-50">
                <div className="container flex items-center justify-start">

                    <div
                        className="bg-[#EDEBFA] min-w-[35px] min-h-[35px]  cursor-pointer relative top-[3px] left-[10px] rounded-full flex items-center justify-center mr-[7px]"
                        onClick={() => props.setMobileMenuVisible(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} className="text-[#473BD0] text-lg relative top-[-1px]" />
                    </div>

                </div>
            </div>
            <ul className={"list-none overflow-x-hidden h-full"}>
                {props.children}
            </ul>
        </div>
    );
}

